import { Button, Stack, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function SelectedItemsBanner({ selected = [], label, handleDelete, disabled = false }) {
    if (!selected.length) return null

    const selectedLabel = selected.length === 1 ? label : label.pluralize()
    const selectedMessage = `${selected.length} ${selectedLabel.titleize()} Selected`
    const deleteMessage = `Remove ${selected.length} ${selectedLabel}`

    return (
        <Stack
            data-cy="selected-banner"
            direction={"row"}
            justifyContent={"space-between"}
            sx={{
                minHeight: "52px",
                my: 2,
                py: 1,
                px: 4,
                borderRadius: 1,
                backgroundColor: grey[100],
                alignItems: "center",
            }}
        >
            <Typography fontWeight={700} variant="body2">
                {selectedMessage}
            </Typography>
            <If truthy={selected.length}>
                <Button
                    disabled={disabled}
                    data-cy={`delete-${label.pluralize()}-button`}
                    color="error"
                    startIcon={<Iconify icon={"gravity-ui:trash-bin"} />}
                    onClick={() => handleDelete(selected)}
                >
                    {deleteMessage}
                </Button>
            </If>
        </Stack>
    )
}
